define('drops/pagination/pagination',[
    'jquery',
    'lq/drop',
    'lq/style'
], function ($, Drop, Style) {
    'use strict';

    var defaults = {
        data: {
            showFirst: true,
            firstLabel: '❮❮',
            showPrevious: true,
            previousLabel: '❮',
            showNext: true,
            nextLabel: '❯',
            showLast: true,
            lastLabel: '❯❯',
            showLabel: true,
            labelTemplate: '${currentPage}/${totalNumberOfPages}',
            verticalAlignment: 'top'
        }
    };

    function Pagination(options) {
        Drop.call(this, $('<div class="pagination-drop boxToBorderSize" />'), defaults, options);

        Style.renderStyles(this);
    }

    Drop.extend(Pagination, Drop);

    Pagination.typeName = 'Pagination';

    Pagination.prototype.postRender = function () {
        this.piping.visibility.apply(this);

        this.applyPosition();

        this.targetDrop = this.piping.dropFactory.findDropByName(this.data.targetDrop);
        if (this.targetDrop)
            this.targetDrop.withOnPageOpened(this.pageOpened.bind(this));
    };

    Pagination.prototype.createPager = function () {
        this.$pager = $('<div class="pager-container" />');

        if (this.data.showFirst || this.data.showPrevious) {
            var $back = $('<div class="back-buttons" />');

            if (this.data.showFirst) {
                this.$first = $('<span class="show-first clickable" />')
                    .text(this.data.firstLabel)
                    .on('click', this.goToFirstPage.bind(this))
                    .appendTo($back);
                Style.renderStyles(this, null, this.$first, this.data.styles, 'navigation', 'navigationHover');
            }

            if (this.data.showPrevious) {
                this.$previous = $('<span class="show-previous clickable" />')
                    .text(this.data.previousLabel)
                    .on('click', this.goToPreviousPage.bind(this))
                    .appendTo($back);
                Style.renderStyles(this, null, this.$previous, this.data.styles, 'navigation', 'navigationHover');
            }

            this.$pager.append($back);
        }

        if (this.data.showLabel) {
            this.$label = $('<div class="paging-info" />')
                .appendTo(this.$pager);
            Style.renderStyles(this, null, this.$label, this.data.styles, 'label', '');
        }

        if (this.data.showLast || this.data.showNext) {
            var $forward = $('<div class="forward-buttons" />');

            if (this.data.showNext) {
                this.$next = $('<span class="show-next clickable" />')
                    .text(this.data.nextLabel)
                    .on('click', this.goToNextPage.bind(this))
                    .appendTo($forward);
                Style.renderStyles(this, null, this.$next, this.data.styles, 'navigation', 'navigationHover');
            }

            if (this.data.showLast) {
                this.$last = $('<span class="show-last clickable" />')
                    .text(this.data.lastLabel)
                    .on('click', this.goToLastPage.bind(this))
                    .appendTo($forward);
                Style.renderStyles(this, null, this.$last, this.data.styles, 'navigation', 'navigationHover');
            }

            this.$pager.append($forward);
        }

        if (this.data.verticalAlignment === 'middle') {
            this.$element.css({
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center'
            });
        } else if (this.data.verticalAlignment === 'bottom') {
            this.$element.css({
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-end'
            });
        } else {
            this.$element.css({
                display: 'inherit',
                flexDirection: '',
                justifyContent: ''
            });
        }

        this.$pager.appendTo(this.$element);
    };

    Pagination.prototype.goToFirstPage = function () {
        if (this.targetDrop)
            this.targetDrop.openPage(0);
    };

    Pagination.prototype.goToPreviousPage = function () {
        if (this.targetDrop)
            this.targetDrop.openPage(this.currentPage - 1);
    };

    Pagination.prototype.goToNextPage = function () {
        if (this.targetDrop)
            this.targetDrop.openPage(this.currentPage + 1);
    };

    Pagination.prototype.goToLastPage = function () {
        if (this.targetDrop)
            this.targetDrop.openPage(this.totalNumberOfPages);
    };

    Pagination.prototype.pageOpened = function (totalNumberOfResults, currentPage, sizeOfPage) {
        this.totalNumberOfResults = totalNumberOfResults;
        this.currentPage = currentPage;
        this.sizeOfPage = sizeOfPage;
        this.totalNumberOfPages = Math.floor(totalNumberOfResults / sizeOfPage - 0.01);

        if (!this.$pager)
            this.createPager();

        var isFirstPage = currentPage === 0;
        var isLastPage = currentPage === this.totalNumberOfPages;

        var firstRecordCurrentPage = (currentPage * sizeOfPage) + 1;
        var lastRecordCurrentPage = isLastPage ? firstRecordCurrentPage + (totalNumberOfResults % sizeOfPage) - 1 : (currentPage + 1) * sizeOfPage;

        if (this.$first) this.$first.toggleClass('not-visible', isFirstPage);
        if (this.$previous) this.$previous.toggleClass('not-visible', isFirstPage);
        if (this.$next) this.$next.toggleClass('not-visible', isLastPage);
        if (this.$last) this.$last.toggleClass('not-visible', isLastPage);

        if (this.$label) {
            this.$label.text(this.data.labelTemplate
                .replace(/\${currentPage}/g, currentPage + 1)
                .replace(/\${totalNumberOfPages}/g, this.totalNumberOfPages + 1)
                .replace(/\${firstRecordCurrentPage}/g, firstRecordCurrentPage)
                .replace(/\${lastRecordCurrentPage}/g, lastRecordCurrentPage)
                .replace(/\${totalNumberOfRecords}/g, totalNumberOfResults));
        }
    };

    return Pagination;
});
